import { render, staticRenderFns } from "./group_message_sender_tbn.vue?vue&type=template&id=22ce7396&"
import script from "./group_message_sender_tbn.vue?vue&type=script&lang=js&"
export * from "./group_message_sender_tbn.vue?vue&type=script&lang=js&"
import style0 from "./group_message_sender_tbn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports